import { useHref, useLocation } from 'react-router-dom';
import { type PageviewLocation } from './pageviewTracker';

/**
 * @description The location of the rendered route, with the router's base path, as PostHog reports it
 * in $pathname and $current_url. It uses the router location, not window.location, because a redirect
 * can change window.location before the effects for the previous route have run.
 * @returns {PageviewLocation} The rendered route's pathname and URL.
 */
export const usePageviewLocation = (): PageviewLocation => {
  const { pathname, search, hash } = useLocation();
  const basePathname = useHref({ pathname });
  const href = useHref({ pathname, search, hash });

  return { pathname: basePathname, currentUrl: `${window.location.origin}${href}` };
};
